module.exports = __webpack_public_path__ + "static/media/SH 25.f3473221.mp3";